import { DropdownField } from '@cian/components';
import * as React from 'react';

export interface IRoomsInDealProps {
  roomsInDeal: number;
  onRoomsInDealChanged(value: number): void;
}

export const RoomsInDeal: React.StatelessComponent<IRoomsInDealProps> = props => (
  <DropdownField
    value={props.roomsInDeal}
    onValueChange={(value: number) => props.onRoomsInDealChanged(value)}
    values={[
      { value: 0, label: 'Неважно' },
      { value: 1, label: '1' },
      { value: 2, label: '2' },
      { value: 3, label: '3' },
      { value: 4, label: '4' },
      { value: 5, label: '5' },
    ]}
  />
);
